// extracted by mini-css-extract-plugin
var _1 = "PdfComponent_pdf__6a5b9";
var _2 = "PdfComponent_pdfItem__1bfb0";
var _3 = "PdfComponent_pdfItems__21d68";
var _4 = "PdfComponent_root__6512c";
export { _1 as "pdf", _2 as "pdfItem", _3 as "pdfItems", _4 as "root" }
